import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 18,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    description: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    caseid: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1
    },

    total: {
        width: '17.5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    unitPrice: {
        width: '17.5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    }
  });

  const InvoiceCaseHeader = () => (
    <View style={styles.container}>
        <Text style={styles.caseid}>Case ID</Text>
        <Text style={styles.description}>Description</Text>
        <Text style={styles.qty}>Qty</Text>
        <Text style={styles.unitPrice}>Unit Price</Text>
        <Text style={styles.total}>Total</Text>
    </View>
  );

  export default InvoiceCaseHeader;
